import React from 'react'

import { AnalyticsCardWrapper } from '../../components/AnalyticsCardWrapper/AnalyticsCardWrapper'
import {
  useAverageOrderValueReportCard,
  useContributionsPerTypeReportCard,
  useConversionRateReportCard,
  useMembershipsActiveMembersReportCard,
  useSalesByCountryReportCard,
  useTopProductsByUnitsSoldReportCard,
  useTotalProfitReportCard,
  useVisitorsReportCard,
} from '../../hooks/reportCards'

export const OverviewAnalytics = () => {
  const totalProfitReportCard = useTotalProfitReportCard({
    type: 'total',
  })
  const shopOrdersReportCard = useContributionsPerTypeReportCard({
    type: 'shop',
  })
  const conversionRatesReportCard = useConversionRateReportCard()
  const visitorsReportCard = useVisitorsReportCard()
  const membershipsActiveMembersReportCard = useMembershipsActiveMembersReportCard()
  const averageOrderValueReportCard = useAverageOrderValueReportCard()
  const topProductsByUnitsSoldReportCard = useTopProductsByUnitsSoldReportCard()
  const salesByCountryReportCard = useSalesByCountryReportCard()

  return (
    <>
      <AnalyticsCardWrapper {...totalProfitReportCard} />
      <AnalyticsCardWrapper {...shopOrdersReportCard} />
      <AnalyticsCardWrapper {...conversionRatesReportCard} />
      <AnalyticsCardWrapper {...visitorsReportCard} />
      <AnalyticsCardWrapper {...membershipsActiveMembersReportCard} />
      <AnalyticsCardWrapper {...averageOrderValueReportCard} />
      <AnalyticsCardWrapper {...topProductsByUnitsSoldReportCard} />
      <AnalyticsCardWrapper {...salesByCountryReportCard} />
    </>
  )
}
